export const RANK_CONFIG = {
    RANK_BASE_URL : process.env.REACT_APP_RANKALYZER_ENDPOINT || 'https://rankalyzer.thomasnet.com',
    RANK_SIGNUP_PATH : '/a/login',
    RANK_LOGOUT_PATH: '/a/lgout'
 };